import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocReportsTeamRoute } from '@jira/router-routes__eoc-reports-routes/src/eocReportsTeamRoute.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { resources as opsReportsResources } from '@atlassian/eoc-ops-reports-common/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import { OpsReports, LazyOpsReports } from './ui/spa/eoc/ops-reports/index.tsx';

export const eocReportsTeamRouteEntry: Route = createEntry(eocReportsTeamRoute, () => ({
	group: 'eoc',
	ufoName: 'operations.reports.team-dashboard',
	// eslint-disable-next-line no-restricted-syntax
	component: OpsReports,
	layout: opsTeamLayout,

	// oxlint-disable-next-line typescript/consistent-type-assertions -- spread resource arrays are not assignable to RouteResources
	resources: [
		...getNavigationResources(),
		...teamDashboardResources(),
		...opsReportsResources(),
		getConsolidationStateResource(),
	] as RouteResources,

	navigation: {
		menuId: MenuIdPeople,
		horizontal: AsyncHorizontalOperationsNav,
	},

	forPaint: [
		LazyHorizontalOperationsNav,
		LazyAtlassianNavigation,
		LazyOpsReports,
		LazyTeamDashboardSidebar,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
